import React from 'react';
import Card from '../Card';

const DashCard = ({ 
  titulo, 
  valor, 
  icon, 
  trend, 
  trendValue, 
  variant = 'default',
  className = '',
  onClick 
}) => {
  const getTrendIcon = () => {
    if (!trend) return null;
    
    if (trend === 'up') {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M7 14l3-3 2 2 7-7"/>
          <path d="M17 8l-7 7-3-3-7 7"/>
        </svg>
      );
    }
    
    if (trend === 'down') {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M7 10l3 3 2-2 7 7"/>
          <path d="M17 16l-7-7-3 3-7-7"/>
        </svg>
      );
    }
    
    return null;
  };

  const getTrendColor = () => {
    if (!trend) return 'var(--gray-500)';
    return trend === 'up' ? 'var(--success-color)' : 'var(--error-color)';
  };

  return (
    <Card
      variant={variant}
      className={`dash-card ${className}`}
      onClick={onClick}
    >
      <div className="dash-card-content">
        <div className="dash-card-header">
          {icon && (
            <div className="dash-card-icon">
              {icon}
            </div>
          )}
          <div className="dash-card-info">
            <h3 className="dash-card-title">{titulo}</h3>
            {trend && (
              <div className="dash-card-trend" style={{ color: getTrendColor() }}>
                {getTrendIcon()}
                <span className="trend-value">{trendValue}</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="dash-card-value">
          {typeof valor === 'number' ? (
            <span className="value-number">{valor.toLocaleString('pt-BR')}</span>
          ) : (
            <span className="value-text">{valor}</span>
          )}
        </div>
      </div>
    </Card>
  );
};

export default DashCard;
